import React from 'react';
import { observer } from "mobx-react-lite";
import { DynamicMapElementNPCModel } from '../../../shared/game/dynamicMapElements/DynamicMapElementNPCModel';
import { DynamicMapElementNPCPropertiesEditor } from './DynamicMapElementNPCPropertiesEditor';
import { DynamicMapElementAnimationElementModel } from '../../../shared/game/dynamicMapElements/DynamicMapElementAnimationElementModel';
import { DynamicMapElementAnimationElementPropertiesEditor } from './DynamicMapElementAnimationElementPropertiesEditor';
import { DynamicMapElementAreaTriggerModel } from '../../../shared/game/dynamicMapElements/DynamicMapElementAreaTriggerModel';
import { DynamicMapElementAreaTriggerPropertiesEditor } from './DynamicMapElementAreaTriggerPropertiesEditor';
import { DynamicMapElementMapMarkerModel } from '../../../shared/game/dynamicMapElements/DynamicMapElementMapMarkerModel';
import { DynamicMapElementMapMarkerPropertiesEditor } from './DynamicMapElementMapMarkerPropertiesEditor';
export const DynamicMapElementPropertiesEditor = observer(({
  element,
  mapEditorStore
}) => {
  if (element instanceof DynamicMapElementNPCModel) {
    return /*#__PURE__*/React.createElement(DynamicMapElementNPCPropertiesEditor, {
      element: element,
      mapEditorStore: mapEditorStore
    });
  }

  if (element instanceof DynamicMapElementAnimationElementModel) {
    return /*#__PURE__*/React.createElement(DynamicMapElementAnimationElementPropertiesEditor, {
      element: element,
      mapEditorStore: mapEditorStore
    });
  }

  if (element instanceof DynamicMapElementAreaTriggerModel) {
    return /*#__PURE__*/React.createElement(DynamicMapElementAreaTriggerPropertiesEditor, {
      element: element,
      mapEditorStore: mapEditorStore
    });
  }

  if (element instanceof DynamicMapElementMapMarkerModel) {
    return /*#__PURE__*/React.createElement(DynamicMapElementMapMarkerPropertiesEditor, {
      element: element,
      mapEditorStore: mapEditorStore
    });
  }

  return /*#__PURE__*/React.createElement("div", null, "Unimplemented dynamic map element: ", element.$modelType);
});